import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import IntlMessages from '../../components/utility/intlMessages';

import ServiceComponent from '../../components/status/service';
import Maintenance from '../../components/status/activeMaintenance';
import Loader from '../../components/utility/loader';

import actions from '../../redux/status/actions';
import urlProvider from '../../helpers/urlProvider';
import logoImage from '../../image/logo.png';
import './status.scss';

class Status extends Component {
    componentDidMount() {       
        this.props.getStatusData();

        this.intervalId = setInterval(() =>{
            this.props.getStatusData(false);
        }, 3000000);
    }

    componentWillUnmount() {
        if(this.intervalId) {
            clearInterval(this.intervalId);
        }
    }

    renderActiveMaintenance() {
        const { activeMaintenances } = this.props;
        if(activeMaintenances && activeMaintenances.length > 0)
        {
            return (
            <div className="components">
                <div className="head">
                    <p>Active Maintenance</p>
                </div>
                {activeMaintenances.map((m, index) => {
                    return (<Maintenance maintenance={m} key={index}/>)
                })}
            </div>);
        }

        return null;
    }

    renderScheduledMaintenance() {
        const { scheduledMaintenances } = this.props;
        if(scheduledMaintenances && scheduledMaintenances.length > 0)
        {
            return (
            <div className="components">
                <div className="head">
                    <p>Scheduled Maintenance</p>
                </div>
                {scheduledMaintenances.map((m, index) => {
                    return (<Maintenance maintenance={m} key={index}/>)
                })}
            </div>);
        }

        return null;
    }

    renderServices() {
        const { components } = this.props;
        if(components.length > 0)
        {
            const ordered = _.orderBy(components, ['state'],['desc']);
            return (
            <div className="components">
                <div className="head">
                    <p>Services</p>
                </div>
                {ordered.map((comp, index) => {
                    return (<ServiceComponent {...comp} key={index}/>)
                })}
            </div>
            );
        }

        return null;
    }

    render() {
        return (
            <div className="status">
                <div className="block"></div>
                <div className="header">
                    <div className="pbs-logo">
                        <img src={logoImage} alt="PBS logo"/>
                        <p className="title">
                            Status Page
                        </p>
                    </div>
                    <div className="pbs-login">
                    { this.props.isLoggedIn ?
                        <div className="title">
                            <Link to="/admin">
                                <IntlMessages id="stausPage.dashboard" />
                            </Link>
                        </div>
                        :<div
                            onClick={() => { window.location.href = urlProvider.getLoginUrl(); }}
                        >
                            <i className="ion-person" />
                            <span className="title">
                                <IntlMessages id="stausPage.login" />
                            </span>
                        </div>
                    }
                    </div>
                </div>
                {this.props.isLoading ?
                <Loader/>
                :<div>
                    {this.renderActiveMaintenance()}
                    {this.renderServices()}
                    {this.renderScheduledMaintenance()}
                    <p className="have-a-problem">
                        Are you having an issue and services are operational?
                        <a href="https://sharepoint.teampbs.com/sites/techsupport/Pages/Ticket.aspx">Submit a Ticket</a>.
                    </p>
                </div>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        isLoggedIn: state.Auth.isLoggedIn,
        ...state.Status
    };
}

export default connect(mapStateToProps, actions)(Status);
